import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { useLocation } from 'react-router'
import { DownloadJpg } from '../../../../../../../common/downloadJpg'
import { UseI18n } from '../../../../../../../common/hooks/useI18n'
import { Element } from '../../../../../../../common/html/element'
import { Icon } from '../../../../../../../common/html/icon'
import { Panel } from '../../../../../../../common/panel'
import { SelectCustom } from '../../../../../../../common/selectCustom'
import { Tooltip } from '../../../../../../../common/tooltip'
import { selectCompanyInfo } from '../../../../../../common/header/companyInfo/store/slice'
import { getHighlightScore } from '../../../../../store/slice'
import '../../../../lang/i18n'
import {
  downloadHistoricalChange,
  getHistoricalChangeDrdDataThunk,
} from '../../../../store/thunk'
import { parseValueToParams } from '../helper'
import { mapViewBy } from './constants'
import CorporateRiskScoreContent from './CorporateRiskScoreContent'

const CorporateRiskScore = ({ hiddenDownload }) => {
  const location = useLocation()
  const dispatch = useDispatch()
  const { riskScore } = useSelector(getHighlightScore())
  const isDisabled = riskScore === null || riskScore === undefined
  const labelCorporateRiskScore = UseI18n('corporateRiskScore.title')
  const label = UseI18n('corporateRiskScore.historicalChange')
  const labelDetails = UseI18n('score.main.DETAILS')
  const { organizationShortName, organizationName, taxCode } =
    useSelector(selectCompanyInfo)
  const params = new Proxy(new URLSearchParams(location.search), {
    get: (searchParam, prop) => searchParam.get(prop),
  })

  const [viewBy, setViewBy] = useState(mapViewBy.chart.value)
  const isViewByChart = viewBy === mapViewBy.chart.value

  const [filterTime, setFilterTime] = useState({
    from: null,
    to: null,
    timeFrequency: null,
  })

  const handleChooseViewBy = (item) => {
    if (item.value !== viewBy) {
      setViewBy(item.value)
    }
  }

  const downloadCsv = () => {
    const { from, to, timeFrequency } = filterTime
    const fromParams = parseValueToParams(from, timeFrequency)
    const toParams = parseValueToParams(to, timeFrequency)

    return downloadHistoricalChange({
      OrganizationId: params.organizationId,
      TimeFrequency: timeFrequency,
      FromQuater: fromParams.Quarter || '',
      FromYear: fromParams.Year || '',
      FromMonth: fromParams.Month || '',
      ToQuater: toParams.Quarter || '',
      ToYear: toParams.Year || '',
      ToMonth: toParams.Month || '',
    })
  }

  const renderRightHeader = () => {
    return (
      <Element
        className="dFlex alignItemsCenter"
        style={{ color: '#3A414B', marginRight: isViewByChart ? 0 : -16 }}
      >
        <Translate value="financialAnalysis.VIEW_BY" />
        <SelectCustom
          isBorderNone
          isI18n
          activeItem={Object.values(mapViewBy).find(
            (item) => item.value === viewBy,
          )}
          data={Object.values(mapViewBy)}
          chooseItem={handleChooseViewBy}
        />
        {!hiddenDownload && isViewByChart && (
          <DownloadJpg
            data={{
              disabled: isDisabled,
              arrName: [
                labelCorporateRiskScore,
                labelDetails,
                organizationShortName || organizationName || taxCode || '',
              ],
              titleJpg: labelCorporateRiskScore,
              domId: 'boxInfoId',
            }}
          >
            <DownloadJpg
              data={{
                disabled: isDisabled,
                arrName: [
                  label,
                  labelDetails,
                  organizationShortName || organizationName || taxCode || '',
                ],
                titleJpg: label,
                domId: 'historicalChangeChartId',
              }}
            />
          </DownloadJpg>
        )}
      </Element>
    )
  }

  useEffect(() => {
    dispatch(
      getHistoricalChangeDrdDataThunk({
        OrganizationId: params.organizationId,
      }),
    )
  }, [])

  return (
    <Panel
      isI18n
      label="corporateRiskScore.title"
      renderLabel={() => {
        return (
          <div>
            <Tooltip
              contentStyle={{
                display: 'flex',
                alignItems: 'center',
                paddingLeft: 4,
              }}
              tooltipStyle={{
                maxWidth: 400,
              }}
              tooltipContent={
                <div className="textCenter" style={{ textAlign: 'justify' }}>
                  <Translate value="corporateRiskScore.tooltipTitle" />
                </div>
              }
            >
              <Icon
                className="icon-info-circle"
                style={{ fontSize: 16, color: '#9C9C9C' }}
              />
            </Tooltip>
          </div>
        )
      }}
      renderRightHeader={renderRightHeader}
      downloadJpgParams={
        !hiddenDownload || isViewByChart
          ? undefined
          : {
              disabled: isDisabled,
              arrName: [
                labelCorporateRiskScore,
                labelDetails,
                organizationShortName || organizationName || taxCode || '',
              ],
              titleJpg: labelCorporateRiskScore,
              domId: 'boxInfoId',
            }
      }
      downloadCsv={
        !hiddenDownload || isViewByChart
          ? undefined
          : {
              disabled: false,
              downloadFunc: downloadCsv,
            }
      }
    >
      <CorporateRiskScoreContent
        filterTime={filterTime}
        setFilterTime={setFilterTime}
        viewBy={viewBy}
      />
    </Panel>
  )
}

export default CorporateRiskScore
